// Mock data para Gotelip Assistência

export const services = [
  {
    id: 1,
    title: "Computadores",
    description: "Manutenção preventiva e corretiva, limpeza, upgrade de hardware, instalação de software e resolução de problemas.",
    icon: "monitor"
  },
  {
    id: 2,
    title: "Notebooks",
    description: "Troca de tela, teclado, bateria, reparo de placa-mãe, limpeza interna e otimização de performance.",
    icon: "laptop"
  },
  {
    id: 3,
    title: "Celulares",
    description: "Troca de tela, bateria, reparo de conectores, problemas de software, desbloqueio e backup de dados.",
    icon: "smartphone"
  }
];

export const serviceTypes = [
  "Computador Desktop",
  "Notebook",
  "Smartphone",
  "Console"
];

export const problemTypes = [
  "Não liga",
  "Tela quebrada",
  "Bateria viciada",
  "Lentidão",
  "Vírus/Malware",
  "Problema de software",
  "Problema de hardware",
  "Backup de dados",
  "Upgrade",
  "Limpeza",
  "Troca de pasta térmica",
  "Outro"
];

export const contactInfo = {
  whatsapp: "5567981556252",
  instagram: "gotelip.assistencia",
  location: "Campo Grande - MS",
  message: "Entrei em contato pelo website, gostaria de um orçamento"
};

// Mock para salvar formulários (localStorage)
export const saveFormSubmission = (formData) => {
  const submissions = JSON.parse(localStorage.getItem('formSubmissions') || '[]');
  const newSubmission = {
    ...formData,
    id: Date.now(),
    timestamp: new Date().toISOString()
  };
  submissions.push(newSubmission);
  localStorage.setItem('formSubmissions', JSON.stringify(submissions));
  return newSubmission;
};

export const getFormSubmissions = () => {
  return JSON.parse(localStorage.getItem('formSubmissions') || '[]');
};
